import * as actionTypes from "./actionTypes";
import axios from "../../axios-common";
import axiosLms from "../../axios-lmsv2";
import axiosRequest from "../../axios-request/request.methods";

let gapcalc = "";
let formData1 = "";
let formData2 = "";
// export const fetchAllGapData = (payload) => {
//   //console.log("payload=====>", payload);
//   // gapcalc = payload;
//   return {
//     type: actionTypes.FETCH_ALL_GAP_DATA,
//     gapcalc: payload,
//   };
// };

// export const fetchPageFormData1 = (payload) => {
//   //console.log("payload formData1=====>>", payload);
//   // formData1=payload;
//   return {
//     type: actionTypes.FETCH_FORMDATA_PAGE1,
//     formData1: payload,
//   };
// };

// export const fetchPageFormData2 = (payload) => {
//   //console.log("payload formData2=====>>", payload);
//   // formData2=payload;
//   return {
//     type: actionTypes.FETCH_FORMDATA_PAGE2,
//     formData2: payload,
//   };
// };
export const clearGapCalculator=()=>{
  return {
    type:actionTypes.RESET_GAP_DATA,
  }
}

export const storeAllGapCalcFromData = (formData, succMsg) => {
  return {
    type: actionTypes.STORE_ALL_CALC_FORM_DATA,
    formData: formData,
     succMsg: succMsg,
  };
};

// export const storeAllGapCalcFromData = (state, action)=>{
//   // //console.log("formData",formData);
//   // return {
//   //   type: actionTypes.STORE_ALL_CALC_FORM_DATA,
//   //   formData: formData,
//   // }

//   const payload = { ...state.formData, ...action.formData };
//   return updateObject(state, {
//     createLeadLoading: true,
//     formData: payload,
//     // childParsedData:childParsedData,
//   });

// }

export const fetchGapCalcStart = () => {
  return {
    type: actionTypes.FETCH_GAP_CALC_START,
  };
};

export const fetchGapCalcSuccess = (formData) => {
  //console.log("result----->",formData)
  return {
    type: actionTypes.FETCH_GAP_CALC_SUCCESS,
    formData: formData,
  };

 
};

export const fetchGapCalcFail = (error) => {
  return {
    type: actionTypes.FETCH_GAP_CALC_FAIL,
    error: error,
  };
};



// get api form data isase hamse kuch matlb nahi h 

export const getGapDataStart =()=>{
  return {
    type: actionTypes.GET_GAP_DATA_START,
  };
}

export const getGapDataSuccess=(LeadID)=>{
  //console.log("getGapDataSuccess===>",LeadID)
  return {
    type: actionTypes.GET_GAP_DATA_SUCCESS,
    LeadID: LeadID,
  }
}

export const getGapDataFail=(error)=>{
  //console.log("getGapDataFail===>",error)
  return {
    type: actionTypes.GET_GAP_DATA_FAIL,
    error: error,
  }
}


export const fetchGapCalculator = (formData) => {
  //console.log("GAP payload===>", formData);
  return async (dispatch) => {
    dispatch(fetchGapCalcStart());
    let result = await axiosRequest.post("user/goalGapApi", formData, {
      secure: true,
    });
    //console.log("Gap Calculator_______", result);
    if (result) {
      //console.log("result length===>",result)
      return dispatch(fetchGapCalcSuccess(result));
    } else {
      return dispatch(fetchGapCalcFail(result));
    }
  };
};

export const getGapData =(LeadID)=>{
  return async (dispatch) => {
    dispatch(getGapDataStart());
    let result = await axiosRequest.get(`user/getGoal?leadId=${LeadID}`, {
      secure: true,
    });
    //console.log("Get data Calculator_______", result);
    if (result) {
      //console.log("result get length===>",result)
      return dispatch(getGapDataSuccess(result));
    } else {
      return dispatch(getGapDataFail(result));
    }
  };
}
